export const BOOKING_STATUS = {
  NOT_PROCESSED: 'not_processed',
  ACCEPTED: 'accepted',
  CANCELLED: 'cancelled',
  DISABLED: 'disabled',
  REJECTED: 'rejected',
  CANCELLED_BY_USER: 'cancelled_by_user',
};

export const DRIVE_EDITABLE_STATUS = {
  BLUE: 'blue',
  GREEN: 'green',
  GREY: 'grey',
};

export const TRIP_TYPES = {
  ONE_WAY: 'one-way',
  ROUND_TRIP: 'round-trip',
  MULTI_LEG: 'multi-leg',
};

export const TRANSFER_TYPES = {
  FROM_TO_AIRPORT: 'airport',
  IN_TOWN: 'in_town',
  OUT_TOWN: 'out_of_town',
};
